// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=\"checkbox\"] {\n  width: auto;\n  margin-right: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
